import { Record } from 'immutable';
import { AssignedAccounts } from 'records/AssignedAccount';

export const defaultValues = {
  loading: false,
  pageLoading: false,
  count: 0,
  nextOffset: 0,
  hasMore: false,
  nextTerritory: null,
  data: AssignedAccounts(),
  errorMessage: null,
  hasInactive: false,
};

export default class Account extends Record(defaultValues, Account) {
  constructor(values) {
    super({
      ...values,
    });
  }
}
